export const baseURL = "/api/v1";
// export const baseURL =
// "https://ballot-g0chhuhsc0a5hbfd.eastus2-01.azurewebsites.net/api/v1";

export const socketURL =
  "https://ballot-g0chhuhsc0a5hbfd.eastus2-01.azurewebsites.net";
// export const socketURL = "http//:127.0.0.1:8000";
